(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jewelry-finish-filter"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.jewelry-finish-filter a').forEach(link=>{const target=new URL(link.href);const query=new URLSearchParams(location.search);query.delete('page');target.search=query.toString();link.href=target.href;});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-options"] && !Shopify.designMode) return;
  try {
    function sizeOrder(value){
 const s=value.trim().toUpperCase().replace(/,/g,'.').replace(/\s+/g,' ').replace(/^2L$/,'2XL');
 const token=s.match(/(?:^|[\s(])((?:\d+X|X+)S|(?:\d+X|X+)L|XS|S|M|L|XL)(?=$|[\s/()\-])/);
 if(token){let v=token[1];if(v==='S')return [0,0];if(v==='M')return [0,1];if(v==='L')return [0,2];const n=v.match(/^([0-9]+)X/);const count=n?Number(n[1]):(v.match(/X/g)||[]).length;return [0,v.endsWith('S')?-count:2+count];}
 const numeric=s.match(/\d+(?:\.\d+)?/);if(numeric)return [1,Number(numeric[0])];
 return [2,0];
}
function sortSizeNodes(group,nodes){const sorted=nodes.map((el,index)=>({el,index,rank:sizeOrder(el.textContent)})).sort((a,b)=>a.rank[0]-b.rank[0]||a.rank[1]-b.rank[1]||a.index-b.index).map(x=>x.el);if(sorted.every((el,index)=>el===nodes[index]))return;const selected=group.tagName==='SELECT'?group.value:null;sorted.forEach(el=>group.append(el));if(selected!==null)group.value=selected;}
function sortProductSizes(){document.querySelectorAll('[data-size-sort] .option-values').forEach(group=>sortSizeNodes(group,[...group.children]));document.querySelectorAll('select[aria-label],select[name]').forEach(select=>{const label=select.getAttribute('aria-label')||select.name||'';if(/^(size|sizes|shoe size|maat|taille)$/i.test(label))sortSizeNodes(select,[...select.options]);});}
sortProductSizes();document.addEventListener('shopify:section:load',sortProductSizes);let sizeSortQueued=false;new MutationObserver(()=>{if(sizeSortQueued)return;sizeSortQueued=true;requestAnimationFrame(()=>{sizeSortQueued=false;sortProductSizes();});}).observe(document.body,{childList:true,subtree:true});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ships-by"] && !Shopify.designMode) return;
  try {
    function updateDispatchDates(){document.querySelectorAll('[data-dispatch-days]').forEach(strip=>{try{const zone=strip.dataset.dispatchTimezone||'America/Toronto';const parts=new Intl.DateTimeFormat('en-CA',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());const part=t=>parts.find(p=>p.type===t).value;const date=new Date(Date.UTC(Number(part('year')),Number(part('month'))-1,Number(part('day')),12));let remaining=Number(strip.dataset.dispatchDays)||1;const holidays=(strip.dataset.dispatchHolidays||'').split(/\s+/);for(let i=0;i<366&&remaining>0;i++){date.setUTCDate(date.getUTCDate()+1);if(date.getUTCDay()!==0&&date.getUTCDay()!==6&&!holidays.includes(date.toISOString().slice(0,10)))remaining--;}if(remaining>0){strip.hidden=true;return;}const time=strip.querySelector('time');time.dateTime=date.toISOString().slice(0,10);time.textContent=new Intl.DateTimeFormat('en-US',{timeZone:'UTC',weekday:'short',month:'short',day:'numeric'}).format(date);}catch(error){}});}
updateDispatchDates();document.addEventListener('shopify:section:load',updateDispatchDates);document.addEventListener('visibilitychange',()=>{if(!document.hidden)updateDispatchDates();});setInterval(updateDispatchDates,60000);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-chart"] && !Shopify.designMode) return;
  try {
    function prepareProductCharts(){document.querySelectorAll('[data-product-section]').forEach(section=>{const chart=section.querySelector('[data-size-chart]');if(!chart||chart.dataset.prepared)return;chart.dataset.prepared='true';if(chart.dataset.descriptionChart!=='true')return;const content=chart.querySelector('.size-chart-content');if(content.querySelector('img,table')||content.textContent.trim())return;const description=section.querySelector('[data-product-description]');if(!description)return;const jewelry=chart.dataset.jewelry==='true';const tables=[...description.querySelectorAll('table')].filter(t=>/\d/.test(t.textContent)&&t.rows.length>1&&(!jewelry||!/(bust|waist|hip|shoulder|chest)/i.test(t.textContent))&&/\b(size|maat|taille|bust|chest|waist|hip|length|shoulder|foot|cm|inch)\b/i.test(t.textContent));tables.forEach(table=>{const previous=table.previousElementSibling;if(previous&&/\b(cm|inch|measurement|size|maat)\b/i.test(previous.textContent)&&previous.textContent.length<200)content.append(previous.cloneNode(true));content.append(table.cloneNode(true));});description.querySelectorAll('img').forEach(img=>{if(!jewelry&&img.getAttribute('src')&&/size.?chart|size.?guide|maattabel/i.test(img.alt||''))content.append(img.cloneNode(true));});if(content.children.length){content.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));chart.hidden=false;}});}
prepareProductCharts();document.addEventListener('shopify:section:load',prepareProductCharts);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.spWishlistReady) return;
  const config = document.getElementById('SpWishConfig');
  const dialog = document.getElementById('SpWishlist');
  if (!config || !dialog) return;
  window.spWishlistReady = true;
  const words = config.dataset;
  const root = words.root.endsWith('/') ? words.root : words.root + '/';
  const key = 'siennas.wishlist.v1';
  const validHandle = h => typeof h === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(h);
  const decode = raw => {
    const data = JSON.parse(raw || '[]');
    if (!Array.isArray(data)) throw new Error('Invalid wishlist');
    return [...new Set(data.filter(validHandle))].slice(0,100);
  };
  let saved = [], storageOK = true, revision = 0, lastOpener;
  try { saved = decode(localStorage.getItem(key)); } catch { storageOK = false; }
  const cache = new Map();
  const list = dialog.querySelector('[data-wish-list]');
  const status = dialog.querySelector('[data-wish-status]');
  const retry = dialog.querySelector('[data-wish-retry]');
  const recSection = dialog.querySelector('[data-wish-recommendations]');
  const recList = dialog.querySelector('[data-wish-rec-list]');
  const recStatus = dialog.querySelector('[data-wish-rec-status]');
  const announce = message => { document.querySelector('[data-wish-announcement]').textContent = message; };
  function sync(scope = document) {
    scope.querySelectorAll('[data-wish-handle]').forEach(button => {
      const selected = saved.includes(button.dataset.wishHandle);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', (selected ? words.remove : words.add) + ': ' + (button.dataset.wishTitle || button.dataset.wishHandle));
      button.title = selected ? words.remove : words.add;
    });
    document.querySelectorAll('[data-wish-open]').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-label', words.title + ' (' + saved.length + ')');
    });
    document.querySelectorAll('[data-wish-count]').forEach(count => {
      count.textContent = String(saved.length); count.hidden = !saved.length;
    });
    dialog.querySelector('[data-wish-storage]').hidden = storageOK;
  }
  function toggle(handle) {
    if (!validHandle(handle)) return;
    if (storageOK) { try { saved = decode(localStorage.getItem(key)); } catch { storageOK = false; } }
    const selected = saved.includes(handle);
    if (!selected && saved.length >= 100) { announce(words.limit); return; }
    saved = selected ? saved.filter(h => h !== handle) : [handle,...saved];
    try { localStorage.setItem(key, JSON.stringify(saved)); storageOK = true; } catch { storageOK = false; }
    sync(); announce(selected ? words.removed : words.added);
    if (dialog.open) render();
  }
  async function request(url) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(url, {signal:controller.signal, credentials:'same-origin'});
      if (!response.ok) { const error = new Error('Wishlist request failed'); error.status = response.status; throw error; }
      return new DOMParser().parseFromString(await response.text(), 'text/html');
    } finally { clearTimeout(timer); }
  }
  function entries(doc, selector) {
    return [...doc.querySelectorAll(selector)].flatMap(node => {
      try {
        const data = JSON.parse(node.dataset.wishEntry);
        if (!validHandle(data.handle) || !data.id) return [];
        node.querySelectorAll('script').forEach(script => script.remove());
        node.querySelectorAll('a[href]').forEach(link=>{
          const href=link.getAttribute('href');
          if(!href.includes('/products/'))return;
          const url=new URL(href,location.origin);
          const variant=href.match(/[?&]variant=(\d+)/)?.[1];
          url.search='';if(variant)url.searchParams.set('variant',variant);
          link.setAttribute('href',url.pathname+url.search);
        });
        return [{data,node}];
      } catch { return []; }
    });
  }
  function getProduct(handle) {
    if (!cache.has(handle)) {
      const promise = request(root + 'products/' + encodeURIComponent(handle) + '?section_id=wishlist-data')
        .then(doc => {
          const current = entries(doc,'[data-wish-current] [data-wish-entry]')[0];
          if (!current) { const error = new Error('Missing product'); error.status=404; throw error; }
          return {current,candidates:entries(doc,'[data-wish-candidates] [data-wish-entry]')};
        }).catch(error => { cache.delete(handle); throw error; });
      cache.set(handle,promise);
    }
    return cache.get(handle);
  }
  async function mapLimited(values, fn) {
    const output = new Array(values.length); let next=0;
    await Promise.all(Array.from({length:Math.min(3,values.length)},async()=>{
      while(next<values.length){const index=next++;try{output[index]={value:await fn(values[index])};}catch(error){output[index]={error};}}
    }));
    return output;
  }
  const normalize = value => String(value || '').trim().toLowerCase();
  const generic = /^(all|frontpage|home|new|new-arrivals|featured|best-sellers|bestsellers|sale|summer-sale|end-of-summer-sale)$|^(import|catalog|sync|shopify)[-_]/;
  const kinds=[['dress',/\bdress(?:es)?\b/i],['sandals',/\bsandals?\b/i],['boots',/\bboots?\b/i],['sneakers',/\bsneakers?|trainers?\b/i],['flats',/\bflats?|loafers?\b/i],['heels',/\bheels?|pumps?\b/i],['cardigan',/\bcardigans?\b/i],['sweater',/\bsweaters?|pullovers?\b/i],['blazer',/\bblazers?\b/i],['jacket',/\bjackets?|coats?\b/i],['blouse',/\bblouses?|shirts?\b/i],['pants',/\bpants|trousers|jeans\b/i],['skirt',/\bskirts?\b/i],['jumpsuit',/\bjumpsuits?|rompers?\b/i],['earrings',/\bearrings?\b/i],['necklace',/\bnecklaces?\b/i],['bracelet',/\bbracelets?\b/i],['bag',/\bbags?|handbags?\b/i]];
  const productKind = product => kinds.find(([,pattern])=>pattern.test(product.title || ''))?.[0] || '';
  function affinity(candidate, seed) {
    let score=0, meaningful=false;
    const ck=productKind(candidate),sk=productKind(seed);
    if(ck && sk && ck!==sk)return 0;
    if(ck && ck===sk){score+=32;meaningful=true;}
    const collections = (seed.collections || []).filter(c => !generic.test(c.handle));
    for (const group of candidate.collections || []) {
      if (!generic.test(group.handle) && collections.some(c=>c.handle===group.handle)) {
        score += 12 + 28 / Math.sqrt(Math.max(1, Number(group.count)/10)); meaningful=true;
      }
    }
    if (normalize(candidate.type) && normalize(candidate.type)===normalize(seed.type)) { score+=30; meaningful=true; }
    const tags = new Set((seed.tags || []).map(normalize).filter(t=>t && !generic.test(t)));
    const commonTags = (candidate.tags || []).map(normalize).filter(t=>tags.has(t));
    if(commonTags.length){score+=Math.min(18,commonTags.length*6);meaningful=true;}
    if (!meaningful) return 0;
    if(normalize(candidate.vendor) && normalize(candidate.vendor)===normalize(seed.vendor))score+=2;
    for(const option of candidate.options || []) {
      if(!/^(color|colour|kleur|couleur)$/.test(normalize(option.name)))continue;
      const other=(seed.options || []).find(o=>/^(color|colour|kleur|couleur)$/.test(normalize(o.name)));
      const values=new Set((other?.values || []).map(v=>normalize(typeof v==='object'?v.name:v)));
      if((option.values || []).some(v=>values.has(normalize(typeof v==='object'?v.name:v))))score+=4;
    }
    if(candidate.price>0 && seed.price>0)score+=6*Math.min(candidate.price,seed.price)/Math.max(candidate.price,seed.price);
    return score;
  }
  function rank(candidates, seeds, excluded) {
    const unique = new Map();
    for(const entry of candidates){if(entry.data.available && !excluded.has(entry.data.handle))unique.set(entry.data.handle,entry);}
    return [...unique.values()].map(entry=>{
      const scores=seeds.map(seed=>affinity(entry.data,seed));
      const best=Math.max(0,...scores);
      return {...entry,score:best + Math.min(10,scores.filter(s=>s>0).length*2)};
    }).filter(entry=>entry.score>0).sort((a,b)=>b.score-a.score || a.data.handle.localeCompare(b.data.handle)).slice(0,6);
  }
  function unavailable(handle,error) {
    const box=document.createElement('div');
    const label=document.createElement('p');label.textContent=handle.replace(/-/g,' ');
    const message=document.createElement('p');message.textContent=error.status===404?words.unavailable:words.error;
    const remove=document.createElement('button');remove.type='button';remove.className='button';remove.dataset.wishHandle=handle;remove.dataset.wishTitle=label.textContent;remove.textContent=words.remove;
    box.append(label,message,remove);return box;
  }
  async function render() {
    const token=++revision, handles=[...saved];
    const focused=document.activeElement?.dataset?.wishHandle;
    status.textContent=handles.length?words.loading:words.empty;
    retry.hidden=true;recSection.hidden=true;recList.replaceChildren();list.replaceChildren();
    if(!handles.length)return;
    const results=await mapLimited(handles,getProduct);
    if(token!==revision || !dialog.open)return;
    const seeds=[],candidates=[];
    results.forEach((result,index)=>{
      if(result.error)list.append(unavailable(handles[index],result.error));
      else {list.append(result.value.current.node.cloneNode(true));seeds.push(result.value.current.data);candidates.push(...result.value.candidates);}
    });
    const failed=results.some(r=>r.error && r.error.status!==404);
    status.textContent=failed?words.error:'';retry.hidden=!failed;
    sync(list);
    if(focused){const target=[...list.querySelectorAll('[data-wish-handle]')].find(b=>b.dataset.wishHandle===focused)||list.querySelector('[data-wish-handle]')||dialog.querySelector('[data-wish-close]');target.focus({preventScroll:true});}
    if(!seeds.length)return;
    recSection.hidden=false;recStatus.textContent=words.loading;
    const related=await mapLimited(seeds.slice(0,6),async seed=>{
      const url=new URL(words.recommendations,location.origin);
      url.searchParams.set('section_id','wishlist-recommendations');url.searchParams.set('product_id',String(seed.id));url.searchParams.set('limit','10');url.searchParams.set('intent','related');
      return entries(await request(url.href),'[data-wish-candidates] [data-wish-entry]');
    });
    if(token!==revision || !dialog.open)return;
    related.forEach(r=>{if(r.value)candidates.push(...r.value);});
    const queries=[...new Set(seeds.map(productKind).filter(Boolean))].slice(0,6);
    const searched=await mapLimited(queries,async query=>{
      const url=new URL(root+'search',location.origin);url.searchParams.set('q',query+'*');url.searchParams.set('type','product');url.searchParams.set('section_id','wishlist-search');
      return entries(await request(url.href),'[data-wish-candidates] [data-wish-entry]');
    });
    if(token!==revision || !dialog.open)return;
    searched.forEach(r=>{if(r.value)candidates.push(...r.value);});
    const ranked=rank(candidates,seeds,new Set(handles));
    recList.replaceChildren(...ranked.map(entry=>entry.node.cloneNode(true)));
    recStatus.textContent=ranked.length?'':(related.some(r=>r.error)?words.error:words.none);
    if(related.some(r=>r.error)&&!ranked.length)retry.hidden=false;
    sync(recList);
  }
  document.addEventListener('click',event=>{
    const toggleButton=event.target.closest('[data-wish-handle]');
    if(toggleButton){event.preventDefault();toggle(toggleButton.dataset.wishHandle);return;}
    const opener=event.target.closest('[data-wish-open]');
    if(opener){lastOpener=opener;dialog.showModal();render();return;}
    if(event.target.closest('[data-wish-close]'))dialog.close();
    if(event.target.closest('[data-wish-retry]')){cache.clear();render();}
  });
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('close',()=>{revision++;lastOpener?.focus({preventScroll:true});});
  window.addEventListener('storage',event=>{if(event.key!==key && event.key!==null)return;try{saved=decode(event.key===null?null:event.newValue);storageOK=true;sync();if(dialog.open)render();}catch{}});
  new MutationObserver(records=>{for(const record of records){for(const node of record.addedNodes){if(node.nodeType===1){if(node.matches('[data-wish-handle],[data-wish-open]'))sync(node.parentNode);else if(node.querySelector('[data-wish-handle],[data-wish-open]'))sync(node);}}}}).observe(document.body,{childList:true,subtree:true});
  sync();
})();
  } catch(e) { console.error(e); }
})();

})();
